import React from 'react';

interface PageHeaderProps {
  children?: React.ReactNode[] | React.ReactNode;
}

const PageHeader = ({ children }: PageHeaderProps) => {
  return <div className="br-pageheader">{children}</div>;
};

export default PageHeader;
